import {SchoolPersonnelModelV1} from 'resources/GeneratedModels/SchoolPersonnel/SchoolPersonnelModel.v1';
import {schoolPersonnelModelValidators} from './SchoolPersonnelModel.validators';
import {schoolPersonnelModelExtensions} from './SchoolPersonnelModel.extensions';

SchoolPersonnelModelV1.extend(schoolPersonnelModelExtensions);
SchoolPersonnelModelV1.addValidators(schoolPersonnelModelValidators);

export {SchoolPersonnelModelV1};
